<template>
  <donut-chart101-template
    :board-ids="[937]"
    :data-type="dataType"
    :graph-id="102"
    :depth="depth"
    date-field="$.body.stdInfo.date"
    :count-fields="['body.inspectChecked[*]']"
    :is-move-detail="false"
    title="작업계획서 현황"
    unit="건"/>
</template>
<script>
/* eslint-disable brace-style */

import DonutChart101Template from "@/views/graph/DonutChart101Template.vue";

export default {
  name: 'DonutChart102',
  components: {DonutChart101Template},
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
    dataType() {
      if (!this.projectId) {
        return 'project';
      }
      // if (this.getLevel === 1) {
      //   return 'countFields';
      // } else {
      //   return 'company';
      // }
      return 'countFields';
    },
    depth() {
      switch (this.getLevel) {
      case 1:
      case 2:
        return 1;
      case 3:
        return 1;
      case 4:
        return 0;
      default:
        return 1;
      }
    }
  }
}
</script>

<style scoped>

</style>
